import { useState } from "react"
import Header from "../components/micro/Header"
import { List } from "../components/micro/List"
import { Mover } from "../components/micro/Mover"
import { Next } from "../components/micro/Next"
import { Page } from "../components/micro/Page"
import { Table } from "../components/micro/Table"
import Topbar from "../components/micro/Topbar"
import { Tr } from "../components/micro/Tr"
import { AnalisiPage } from "./piezometro/AnalisiPage"
import { ConducibilitaPage } from "./piezometro/ConducibilitaPage"
import { LivelloPiezometricoPage } from "./piezometro/LivelloPiezometricoPage"

export function PiezometroPage({
    onBack,
    lv0, lv1, lv2, lv3,
    name,
    coords,
    depth,
    listLv4,
    hoverLv4,
    onMouseEnterRow,
    onMouseLeaveRow,
    onClickRow
}) {

    const [currentSlide, setCurrentSlide] = useState(0)

    const back = () => {
        currentSlide === 0 ? onBack() : setCurrentSlide(0)
    }

    const slideTitles = ['Piezometro', 'Livello piezometrico', 'Conducibilità elettrica e SO4', 'Analisi lab. acque sotterranee']

    return (
        <Page className="piezometro-page">
            <Topbar onBack={back}>{slideTitles[currentSlide]}</Topbar>
            <Header
                lv0={lv0 ? lv0.nome : null}
                lv1={lv1 ? lv1.siglaMacrolotto + (lv1.descrizione ? " - " + lv1.descrizione : "") : null}
                lv2={lv2 ? lv2.nome : null}
                lv3={name}
                lv3Label="Nome: "
                lv3color="white"
                lv3icon='/assets/markers/piezo-sm.png'
            />
            <List>
                <div className="position-relative">
                    <Mover current={currentSlide}>
                        <Page>
                            <Table>
                                <tbody>
                                    <tr className="header-like">
                                        <td colSpan={6}>
                                            <GenericInfo
                                                className='mt-3'
                                                title="Caratteristiche generali"
                                                coords={coords}
                                                depth={depth}
                                            />
                                        </td>
                                    </tr>
                                    <Tr onClick={() => setCurrentSlide(1)}>
                                        <td>Livello piezometrico</td>
                                        <Next><i className="fas fa-chevron-right"></i></Next>
                                    </Tr>
                                    <Tr onClick={() => setCurrentSlide(2)}>
                                        <td>Conducibilità elettrica e SO4</td>
                                        <Next><i className="fas fa-chevron-right"></i></Next>
                                    </Tr>
                                    <Tr onClick={() => setCurrentSlide(3)}>
                                        <td>Analisi lab. acque sotterranee</td>
                                        <Next><i className="fas fa-chevron-right"></i></Next>
                                    </Tr>
                                </tbody>
                            </Table>
                        </Page>
                        <Page>
                            <LivelloPiezometricoPage idPiezometro={lv3.id} nomePiezometro={name} />
                        </Page>
                        <Page>
                            <ConducibilitaPage idPiezometro={lv3.id} nomePiezometro={name} />
                        </Page>
                        <Page>
                            <AnalisiPage idPiezometro={lv3.id} nomePiezometro={name}/>
                        </Page>
                    </Mover>
                </div>
            </List>
        </Page>
    )
}

function GenericInfo({
    title,
    coords,
    depth,
    className,
}) {
    return (
        <Table className={className}>
            <thead>
                <Tr>
                    <td colSpan={2}><strong>{title}</strong></td>
                </Tr>
            </thead>
            <tbody>
                <tr>
                    <td>Coordinate</td>
                    <td>
                        {coords.map((c, i) => <div key={i}>{c}</div>)}
                    </td>
                </tr>
                <tr>
                    <td>Quota</td>
                    <td>{depth} m slm</td>
                </tr>
            </tbody>
        </Table>
    )
}